import {Order, OrderService} from '@domain/model/Order';

const getOrderPendingOfReturn = (orders: Order[]): OrderService | undefined => {
  const ordersPendingReturn = orders.find(
    ({services: {0: order}}) => order.id && order.id.length && order.shippingAddress && order.status === 'RETORNADO',
  );

  if (ordersPendingReturn) {
    return ordersPendingReturn.services[0];
  }
  return undefined;
};

export {getOrderPendingOfReturn};
